export var FilterCategory;
(function (FilterCategory) {
    FilterCategory["INTERACTIONS"] = "Interactions";
    FilterCategory["GEAR"] = "Gear";
    FilterCategory["RECORDING_ATTRIBUTES"] = "Recording Attributes";
    FilterCategory["JAVASCRIPT"] = "Javascript";
    FilterCategory["USER"] = "User";
    FilterCategory["METADATA"] = "Metadata";
    FilterCategory["PERFORMANCE"] = "Performance";
})(FilterCategory || (FilterCategory = {}));
;
export var IssueType;
(function (IssueType) {
    IssueType["CLICK_RAGE"] = "click_rage";
    IssueType["DEAD_CLICK"] = "dead_click";
    IssueType["EXCESSIVE_SCROLLING"] = "excessive_scrolling";
    IssueType["BAD_REQUEST"] = "bad_request";
    IssueType["MISSING_RESOURCE"] = "missing_resource";
    IssueType["MEMORY"] = "memory";
    IssueType["CPU"] = "cpu";
    IssueType["SLOW_RESOURCE"] = "slow_resource";
    IssueType["SLOW_PAGE_LOAD"] = "slow_page_load";
    IssueType["CRASH"] = "crash";
    IssueType["CUSTOM"] = "custom";
    IssueType["JS_EXCEPTION"] = "js_exception";
})(IssueType || (IssueType = {}));
export var FilterType;
(function (FilterType) {
    FilterType["STRING"] = "STRING";
    FilterType["ISSUE"] = "ISSUE";
    FilterType["BOOLEAN"] = "BOOLEAN";
    FilterType["NUMBER"] = "NUMBER";
    FilterType["NUMBER_MULTIPLE"] = "NUMBER_MULTIPLE";
    FilterType["DURATION"] = "DURATION";
    FilterType["MULTIPLE"] = "MULTIPLE";
    FilterType["SUB_FILTERS"] = "SUB_FILTERS";
    FilterType["COUNTRY"] = "COUNTRY";
    FilterType["DROPDOWN"] = "DROPDOWN";
    FilterType["MULTIPLE_DROPDOWN"] = "MULTIPLE_DROPDOWN";
    FilterType["AUTOCOMPLETE_LOCAL"] = "AUTOCOMPLETE_LOCAL";
})(FilterType || (FilterType = {}));
;
export var FilterKey;
(function (FilterKey) {
    FilterKey["ERROR"] = "ERROR";
    FilterKey["MISSING_RESOURCE"] = "MISSING_RESOURCE";
    FilterKey["SLOW_SESSION"] = "SLOW_SESSION";
    FilterKey["CLICK_RAGE"] = "CLICK_RAGE";
    FilterKey["CLICK"] = "CLICK";
    FilterKey["INPUT"] = "INPUT";
    FilterKey["LOCATION"] = "LOCATION";
    FilterKey["VIEW"] = "VIEW";
    FilterKey["CONSOLE"] = "CONSOLE";
    FilterKey["METADATA"] = "METADATA";
    FilterKey["CUSTOM"] = "CUSTOM";
    FilterKey["URL"] = "URL";
    FilterKey["USER_BROWSER"] = "USERBROWSER";
    FilterKey["USER_OS"] = "USEROS";
    FilterKey["USER_DEVICE"] = "USERDEVICE";
    FilterKey["PLATFORM"] = "PLATFORM";
    FilterKey["DURATION"] = "DURATION";
    FilterKey["REFERRER"] = "REFERRER";
    FilterKey["USER_COUNTRY"] = "USERCOUNTRY";
    FilterKey["JOURNEY"] = "JOURNEY";
    FilterKey["REQUEST"] = "REQUEST";
    FilterKey["GRAPHQL"] = "GRAPHQL";
    FilterKey["STATEACTION"] = "STATEACTION";
    FilterKey["REVID"] = "REVID";
    FilterKey["USERANONYMOUSID"] = "USERANONYMOUSID";
    FilterKey["USERID"] = "USERID";
    FilterKey["ISSUE"] = "ISSUE";
    FilterKey["EVENTS_COUNT"] = "EVENTS_COUNT";
    FilterKey["UTM_SOURCE"] = "UTM_SOURCE";
    FilterKey["UTM_MEDIUM"] = "UTM_MEDIUM";
    FilterKey["UTM_CAMPAIGN"] = "UTM_CAMPAIGN";
    FilterKey["DOM_COMPLETE"] = "DOM_COMPLETE";
    FilterKey["LARGEST_CONTENTFUL_PAINT_TIME"] = "LARGEST_CONTENTFUL_PAINT_TIME";
    FilterKey["TIME_BETWEEN_EVENTS"] = "TIME_BETWEEN_EVENTS";
    FilterKey["TTFB"] = "TTFB";
    FilterKey["AVG_CPU_LOAD"] = "AVG_CPU_LOAD";
    FilterKey["AVG_MEMORY_USAGE"] = "AVG_MEMORY_USAGE";
    FilterKey["FETCH_FAILED"] = "FETCH_FAILED";
    FilterKey["FETCH"] = "FETCH";
    FilterKey["FETCH_URL"] = "FETCH_URL";
    FilterKey["FETCH_STATUS_CODE"] = "FETCH_STATUS_CODE";
    FilterKey["FETCH_METHOD"] = "FETCH_METHOD";
    FilterKey["FETCH_DURATION"] = "FETCH_DURATION";
    FilterKey["FETCH_REQUEST_BODY"] = "FETCH_REQUEST_BODY";
    FilterKey["FETCH_RESPONSE_BODY"] = "FETCH_RESPONSE_BODY";
    FilterKey["GRAPHQL_NAME"] = "GRAPHQL_NAME";
    FilterKey["GRAPHQL_METHOD"] = "GRAPHQL_METHOD";
    FilterKey["GRAPHQL_REQUEST_BODY"] = "GRAPHQL_REQUEST_BODY";
    FilterKey["GRAPHQL_RESPONSE_BODY"] = "GRAPHQL_RESPONSE_BODY";
})(FilterKey || (FilterKey = {}));
